module.exports = __webpack_public_path__ + "img/dgq-logo-footer.27a1f7df.png";